import React from 'react';

import { useTranslation } from 'react-i18next';

import { Flex, Input, UiButton } from '@shared/ui';
import { CustomModal } from '@shared/ui/CustomModal/CustomModal';
import { TFolderModes } from '@widgets/Files/model/types/modalMode.type';
import { useFolderModal } from '@widgets/Files/UI/Modals/useFolderModal';

import cls from './ModalFiles.module.css';

interface IFolderModalProps {
    folderModalType: TFolderModes;
    onHideModal: () => void;
    isShow: boolean;
}

export const FolderModal = ({ folderModalType, onHideModal, isShow }: IFolderModalProps) => {
    const {
        t,
        headerText,
        inputValue,
        inputRef,
        inputError,
        submitButtonRef,
        handleInput,
        handleSubmitForm,
    } = useFolderModal({
        folderModalType,
        onHideModal,
        isShow,
    });
    return (
        <>
            <CustomModal.Header>{headerText}</CustomModal.Header>
            <CustomModal.Body width="476px" classes={cls.textAlignCenter}>
                <form id="folder-modal" onSubmit={handleSubmitForm}>
                    <Input
                        classes={['']}
                        value={inputValue}
                        error={inputError.text}
                        innerRef={inputRef}
                        onValueChange={handleInput}
                        inputClassName={cls.input}
                        errorClassName={cls.inputError}
                        name="folderInput"
                    />
                </form>
            </CustomModal.Body>
            <CustomModal.Footer>
                <Flex justify="between" fullWidth>
                    <UiButton
                        btnText={t('Files.FolderModal.CancelBtn.text')}
                        btnColor="secondary"
                        onClick={onHideModal}
                        className={cls.FolderModalBtn}
                    />
                    <UiButton
                        btnText={
                            folderModalType === 'folderCreate'
                                ? t('Files.FolderModal.CreateBtn.text')
                                : t('Files.FolderModal.EditBtn.text')
                        }
                        btnColor="primary"
                        innerRef={submitButtonRef}
                        type="submit"
                        className={cls.FolderModalBtn}
                        form="folder-modal"
                    />
                </Flex>
            </CustomModal.Footer>
        </>
    );
};
